import React from 'react'
import { postToServer } from '../../../store/utils/postToServer';
;

type Props = {
  link: string;
  text: string;
  className: string;
}



export const LinkOut = ({link, text, className}: Props) => {
  return (
    // <span className={className} onClick={() => (window as any).cep.util.openURLInDefaultBrowser(`${link}`)}>{text}</span>
    <span className={className} onClick={() => postToServer('openUrl', {url: link})}>{text}</span>
  )
}
